// @flow
import clsx from 'clsx';

import { Icon } from './Icon';
import type { AvailabilityIconName } from './Icon/IconContainer';

import styles from './ProvidedContainerLayout.scss';

type ContainerProps = {
  className?: string,
  children: React.Node,
  availabilityIconName: AvailabilityIconName,
  renderButton?: React.Node,
  id?: string,
};

export function ProvidedContainerLayout({
  className,
  children,
  renderButton,
  availabilityIconName,
  id,
}: ContainerProps): React.MixedElement {
  return (
    <div id={id} className={clsx(styles.root, className)}>
      <div className={styles.containerInfo}>
        <Icon iconName={availabilityIconName} />
        {children}
      </div>
      <div className={styles.containerPrices}>{renderButton}</div>
    </div>
  );
}
